let loader = $('.loader-wrapper');
import AOS from 'aos';

window.onload = function () {
	$(loader).fadeOut();
	$('body').removeClass('hidden');
	AOS.init();
	// fix AOS chrome
	setTimeout(() => {AOS.refresh();}, 150);
}
